import { LogLevel } from '@azure/msal-browser';

// M365 Corporate Tenant Configuration
// IMPORTANT: This uses login.microsoftonline.com, NOT ciamlogin.com
const CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID || 'eeb48270-e7ff-41be-86bb-50200caf540c';
const TENANT_ID = import.meta.env.VITE_AZURE_TENANT_ID || 'fa14cebd-095b-4a9d-b7de-75d393ceb764';

// M365 uses standard Microsoft login endpoint
const AUTHORITY = `https://login.microsoftonline.com/${TENANT_ID}`;

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: '/',
    // M365 tenants use login.microsoftonline.com, NOT ciamlogin.com
    knownAuthorities: ['login.microsoftonline.com']
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
        }
      }
    }
  }
};

/**
 * Scopes for authentication
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read']
};

/**
 * API configuration for admin endpoints
 */
export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_URL || '/api',
  scopes: ['openid', 'profile', 'email']
};
